import * as React from "react"
import { FC } from "react"
import Link from "gatsby-link"

import { faqs } from "config/faq"
import * as styles from "./styles.module.scss"
import LinkUnderline from "../../LinkUnderline"
import SummaryVideos from "../SummaryVideos"

export interface SummaryProps {
  bare: boolean
}

const Summary: FC<SummaryProps> = ({ bare }) => {
  return (
    <section className={styles.faqSummary}>
      <div className={styles.pagePadding}>
        <ul className={styles.sectionList}>
          {faqs.map((section) => (
            <li className={styles.sectionItem} key={section.id}>
              <h2 className={styles.heading}>{section.title}</h2>
              <ul className={styles.questionList}>
                {section.faq.map((question) => (
                  <li className={styles.questionItem} key={question.id}>
                    <Link
                      className={styles.questionLink}
                      to={`/faq/${section.id}/${question.id}${
                        bare ? "?bare=true" : ""
                      }`}
                    >
                      <h4 className={styles.question}>
                        <LinkUnderline>{question.question}</LinkUnderline>
                      </h4>
                    </Link>
                  </li>
                ))}
              </ul>
              {section.videos && (
                <div className={styles.videos}>
                  <SummaryVideos videos={section.videos} />
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default Summary
